import { ErrorIcon } from '@THC/components/Icons/Error';
import { MDText } from 'i18n-react';

import { IconTooltip } from 'Components/shared/IconTooltip';
import { triggerMaxFeeTooltipClickedEvent } from 'Services/analytics/events';
import useFeesStore from 'Stores/FeesStore/FeesStore';

import { BID_ERROR_MESSAGE_ID, BID_INPUT_ID } from '../ProxyBidActions.const';
import type { BidLabelProps } from '../ProxyBidActions.types';

import LocalTexts from './ProxyBidLabel.texts';

import styles from './ProxyBidLabel.module.scss';

const LocalT = new MDText(LocalTexts);

export const ProxyBidLabel: React.FC<BidLabelProps> = ({ errorMessage }) => {
	const { PROXY_BID_INCREMENT } = useFeesStore();

	const handleOnClickOrHover = () => {
		triggerMaxFeeTooltipClickedEvent(false);
	};

	return (
		<>
			<div className={styles.label}>
				<label htmlFor={BID_INPUT_ID}>{LocalT.translate('proxyLabel')}</label>
				<IconTooltip
					content={
						<div className={styles.tooltip}>
							{LocalT.translate('proxyTooltip', {
								value: PROXY_BID_INCREMENT,
							})}
						</div>
					}
					onClick={handleOnClickOrHover}
					onMouseEnter={handleOnClickOrHover}
				/>
			</div>
			{errorMessage ? (
				<div className={styles.errorMessage}>
					<ErrorIcon filled size="small" />
					<span id={BID_ERROR_MESSAGE_ID} role="alert">
						{errorMessage}
					</span>
				</div>
			) : null}
		</>
	);
};
